import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateLabelPipe',
  standalone: true
})
export class DateLabelPipe implements PipeTransform {

  private months = [
    'Enero','Febrero','Marzo','Abril','Mayo','Junio',
    'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
  ];

  transform(value: string): string {
    if (!value) return '';

    const [dmy] = value.split('T');
    const [dd, mm, yyyy] = dmy.split('-').map(Number);

    return `${dd} ${this.months[mm - 1]} ${yyyy}`; //15 Diciembre 2025
  }
}
